import { PropsWithChildren } from "react";
import classes from "./classes.module.scss";
import Footer from "components/materials/Footer";
import Banner from "./Banner";
import ProfessionalSpaceHeader from "./ProfessionalSpaceHeader";
import ProfessionalSpaceNavMenu from "./ProfessionalSpaceNavMenu";

type IProps = PropsWithChildren<{}>;

export default function ProfessionalSpaceLayout(props: IProps) {
	return (
		<div className={classes["root"]}>
			<div className={classes["header"]}>
				<ProfessionalSpaceHeader />
				<Banner />
			</div>
			<div className={classes["content"]}>
				<ProfessionalSpaceNavMenu className={classes["nav-menu"]} />
				{props.children}
			</div>
			<Footer />
		</div>
	);
}
